<template lang="pug">
AuthorEditor(:key="fileName" v-bind="courseAndFirm")
</template>

<script setup lang="ts">
import AuthorEditor from './AuthorEditor.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import getCourseAndFirmFromFile from '../lib/getCourseAndFirmFromFile';

const fileName = computed(() => useRoute().params.fileName as string);
const courseAndFirm = computed(() => getCourseAndFirmFromFile(fileName.value));
</script>
